import React, { useState } from "react";
import Logo from "../../assets/img/logo.svg";
import JikeiGakuenLogo from "../../assets/img/JIKEITeamLogo.webp";
import JikeiComLogo from "../../assets/img/JIKEICOMLogo.webp";
import styles from "./header.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getName } from "../../redux/reducers/user";
import { getAuthToken, logoutRequest } from "../../redux/reducers/auth";
import SonicLink from "../../common/routing/SonicLink";

const Header: React.FC = () => {
  const username = useAppSelector(getName);
  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();

  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  const logoutHandler = () => {
    if (auth_token) {
      dispatch(logoutRequest(auth_token));
    }
  };

  return (
    <header>
      <div className={styles["header__wrapper"]}>
        <div className={styles["header__container-top"]}>
          <ul className={styles["header__logo-list"]}>
            <li className={styles["header__logo-item"]}>
              <img src={Logo} />
            </li>
            <li className={styles["header__logo-item"]}>
              <img src={JikeiGakuenLogo} />
            </li>
            <li className={styles["header__logo-item"]}>
              <img src={JikeiComLogo} />
            </li>
          </ul>
          <div className={styles["header__menu"]}>
            <div
              onClick={toggleClass}
              className={
                isActive
                  ? `${styles["header__menu-administrator"]} ${styles["show"]}`
                  : `${styles["header__menu-administrator"]}`
              }
            >
              <FontAwesomeIcon
                icon={["fal", "user-circle"]}
                className={styles["header__menu-icon"]}
              />
              <span className={styles["header__menu-name"]}>{username}</span>
              <FontAwesomeIcon
                icon={["fal", "chevron-down"]}
                className={styles["header__menu-dropdown"]}
              />
            </div>
            <ul className={styles["header__admin-operation"]}>
              <li className={styles["header__admin-operation__item"]}>
                <SonicLink
                  to="/mypage"
                  className={styles["header__admin-operation__btn"]}
                >
                  SELeCTマイページ
                </SonicLink>
              </li>
              <li className={styles["header__admin-operation__item"]}>
                <button
                  onClick={logoutHandler}
                  className={styles["header__admin-operation__btn"]}
                >
                  ログアウト
                  <FontAwesomeIcon icon={["fal", "sign-out-alt"]} />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
